import React, { useEffect, useRef } from "react";
import { AgCharts } from "ag-charts-community";

/**
 * PieChartContainer renders a pie chart using AgCharts.
 *
 * @param {string} title - The title of the chart.
 * @param {Array} data - The data to be displayed in the chart.
 * @param {string} angleKey - The key for the pie slice values.
 * @param {string} legendItemKey - The key for the legend labels.
 * @param {Object} chartOptions - Additional chart configuration options.
 */
export const PieChartContainer = ({ title = "Metrics", data, angleKey = "count", legendItemKey = "label", chartOptions = {}, ...props }) => {
    const chartRef = useRef(null);

    useEffect(() => {
        if (!chartRef.current) return;

        // Define pie chart options
        const options = {
            container: chartRef.current,
            title: {
                text: title ?? "Metrics",
                fontSize: 16,
            },
            data,
            series: [
                {
                    type: "pie",
                    angleKey,
                    legendItemKey,
                    sectorLabelKey: angleKey,
                    sectorLabel: {
                        color: '#000000',
                        fontSize: 10,
                    },
                    ...chartOptions.series, // Allow customization of series options
                },
            ],
            legend: {
                position: 'left',
            },
            background: {
                fill: '#ffffff',
            },
        };

        // Create the chart
        const chart = AgCharts.create(options);

        // Cleanup on unmount
        return () => {
            chart.destroy();
        };
    }, [title, data, angleKey, legendItemKey, chartOptions]);

    return <div ref={chartRef} style={{ width: "100%", height: "100%" }} />;
};